import './Navigation.css'
import * as React from 'react'
import { Link, withRouter } from "react-router-dom"
import * as firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/firestore'

class NavigationState {
    public roles: string[] = []
    public showNavigation: boolean = false
}
class Navigation extends React.Component<any, NavigationState>{
    private authListener: firebase.Unsubscribe

    constructor(props: any) {
        super(props)

        const newState = new NavigationState()
        this.logout = this.logout.bind(this)

        this.authListener = firebase.auth().onAuthStateChanged(user => {
            if (user) {
                firebase.firestore().collection('users').doc(user.uid).get().then(snapshot => {
                    if (snapshot.exists) {
                        const userRoles = snapshot.data()!.roles
                        if (userRoles.includes('replay')) {
                            this.props.history.push('/replay')
                        }
                        this.setState({
                            roles: userRoles,
                            showNavigation: true && snapshot.data()!.isConfirmed
                        })
                    } else {
                        this.setState({ showNavigation: false })
                    }
                })
            } else {
                this.setState({
                    roles: [],
                    showNavigation: false
                })
            }
        })
        this.state = newState
    }

    public componentWillUnmount() {
        if (this.authListener !== null) {
            this.authListener()
        }
    }

    public render() {
        return (
            <div className="Navigation">
                {this.state.showNavigation &&
                    <div className="menu">
                        {(this.state.roles.includes('teacher') || this.state.roles.includes('admin')) && <Link to="/">Live</Link>}
                        {(this.state.roles.includes('teacher') || this.state.roles.includes('admin') || this.state.roles.includes('replay')) && <Link to="/replay">Replay</Link>}
                        {this.state.roles.includes('admin') && <Link to="/daily">Video On Demand</Link>}
                        {this.state.roles.includes('admin') && <Link to="/schedule">Schedule</Link>}
                        {this.state.roles.includes('admin') && <Link to="/promocode">Promo Code</Link>}
                        {this.state.roles.includes('admin') && <Link to="/teacher">Teacher</Link>}
                        <Link to="/login" onClick={this.logout}>Logout</Link>
                    </div>
                }
            </div>
        )
    }

    private logout() {
        firebase.auth().signOut().then(_ => {
            window.location.reload()
        })
    }
}


export default withRouter(Navigation)


// WEBPACK FOOTER //
// ./src/components/navigation/Navigation.tsx